import { Component, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Router, Event as NavigationEvent } from '@angular/router';

@Component({
    selector: 'discountapp',
    template: ` <router-outlet></router-outlet> `,
})
export class DiscountComponent {}
